import { SVG, SVGProps } from './svg'

export function IconCaretVertical(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M15.86 8.94c.09.1.14.22.14.36 0 .13-.05.26-.14.35l-.18.2c-.1.1-.21.15-.34.15H8.66a.44.44 0 0 1-.34-.15l-.18-.2A.52.52 0 0 1 8 9.3c0-.14.05-.27.14-.36l3.53-3.79a.43.43 0 0 1 .65 0l3.54 3.79ZM8.14 15.06A.52.52 0 0 1 8 14.7c0-.13.05-.26.14-.35l.18-.2c.1-.1.21-.15.34-.15h6.68c.13 0 .25.05.34.15l.18.2a.52.52 0 0 1 0 .71l-3.53 3.79a.43.43 0 0 1-.65 0l-3.54-3.79Z" />
    </SVG>
  )
}
